import React from "react";
import { useCart } from "../context/CartContext";

const CartItem = ({ item }) => {
  const { removeFromCart } = useCart();

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #ddd",
        padding: "10px 0",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={item.image}
          alt={item.name}
          style={{
            width: "80px",
            height: "80px",
            objectFit: "cover",
            borderRadius: "8px",
            marginRight: "15px",
          }}
        />
        <div>
          <h3 style={{ margin: 0 }}>{item.name}</h3>
          <p style={{ margin: "5px 0" }}>
            Rs {item.price} × {item.quantity} ={" "}
            <strong>Rs {item.price * item.quantity}</strong>
          </p>
        </div>
      </div>

      <button
        onClick={() => removeFromCart(item.id)}
        style={{
          padding: "6px 12px",
          backgroundColor: "red",
          color: "white",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Remove
      </button>
    </div>
  );
};

export default CartItem;
